.s-color-picker{
  &-widget{
    &-canvas{
    }
  }
}